<template>
  <div>
    <p>There are no meals open for ordering right now.</p>
    <!-- <p>The next available meal is {{nextMeal}}</p> -->
    <p>Meals are open as follows:</p>
    <ul v-if="weekday">
      <li>Breakfast: 6:00 - 10:00</li>
      <li>Lunch: 11:00 - 15:00</li>
      <li>Dinner: 16:30 - 19:00</li>
    </ul>
    <ul v-else>
      <li>Brunch: 11:00 - 15:00</li>
      <li>Supper: 17:30 - 18:00</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NoMealsOpen',
  data() {
    return {
      nextMeal: null,
    }
  },
  mounted () {
    
  },
  computed: {
    ...mapState([
      'weekday',
      'config'
    ]),
  },
};
</script>

<style lang="scss" scoped>

</style>